import { motion } from "framer-motion"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import ExpiringLeases from "../component/expiring-leases"
import { Summary } from "../component/Summary"
import MonthlyLeasePayments from "../component/MonthlyLeasePayment.component"
import { UnitDistributionChart } from "../component/UnitDistribution"
export default function DashBoardComponent() {
  const [userInfo] = useCurrentUser()
  return (
    <main className="max-w-7xl mx-auto py-6 px-4 lg:px-8 mt-16">
      <motion.div
        className={`grid grid-cols-1 gap-5 sm:grid-cols-2 ${userInfo?.role?.key === "super_admin"
            ? "lg:grid-cols-4"
            : "lg:grid-cols-4"
          } mb-8`}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <Summary />
      </motion.div>
      {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 my-2">
        <MonthlyLeasePayments />
        <UnitDistributionChart />
      </div> */}

      {(userInfo?.role?.key === "super_admin" ||
        userInfo?.role?.key === "owner") && (
          <div className="grid grid-cols-1 lg:grid-cols-1 gap-8 my-2">
            <ExpiringLeases />
          </div>
        )}
    </main>
  )
}
